import { Api } from "../config/request";

export default {
  getTripStatistics(params) {
    return Api.get(`/trip/statistics${params}`);
  },
};
